export const MARKETING_PATH = '/marketing';
export const MARKETING_CMS_PATH = `${MARKETING_PATH}/cms`;
export const MARKETING_CMS_SITES_PATH = `${MARKETING_CMS_PATH}/sites`;
export const MARKETING_CMS_NEW_SITE_PATH = `${MARKETING_CMS_SITES_PATH}/new`;
export const MARKETING_CMS_REVIEWS_PATH = `${MARKETING_CMS_PATH}/reviews`;

export const marketingCmsSitePath = (cmsMicrositeGUID: string) => `${MARKETING_CMS_SITES_PATH}/${cmsMicrositeGUID}`;

export const marketingCmsSiteBuilderPath = (cmsMicrositeGUID: string) =>
    `${marketingCmsSitePath(cmsMicrositeGUID)}/builder`;

export const marketingCmsSiteHistoryPath = (cmsMicrositeGUID: string) =>
    `${marketingCmsSitePath(cmsMicrositeGUID)}/history`;

export const marketingCmsReviewPath = (cmsMicrositeGUID: string, cmsContentVersionGUID: string) =>
    `${MARKETING_CMS_REVIEWS_PATH}/${cmsMicrositeGUID}/${cmsContentVersionGUID}`;
